const ADD_CURRENT_USER = 'ADD_CURRENT_USER'
const ADD_USER_PERMISSION = 'ADD_USER_PERMISSION'
const ADD_JWT_TOKEN = 'ADD_JWT_TOKEN'

const FETCH_EMPLOYEE_LIST_WITH_IMAGES = 'containers/User/FETCH_EMPLOYEE_LIST_WITH_IMAGES'
const UPDATE_CUSTOM_VIEWS = 'containers/User/UPDATE_CUSTOM_VIEWS'

export {
  FETCH_EMPLOYEE_LIST_WITH_IMAGES,
  ADD_CURRENT_USER,
  ADD_USER_PERMISSION,
  ADD_JWT_TOKEN,
}
